"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Et = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 720 360", ...props },
    react_1.default.createElement("path", { fill: "#da121a", d: "M0 0h720v360H0z" }),
    react_1.default.createElement("path", { fill: "#fcdd09", d: "M0 0h720v240H0z" }),
    react_1.default.createElement("path", { fill: "#078930", d: "M0 0h720v120H0z" }),
    react_1.default.createElement("g", { transform: "translate(360 180)" },
        react_1.default.createElement("circle", { r: 120, fill: "#0f47af" }),
        react_1.default.createElement("g", { id: "et_svg__a" },
            react_1.default.createElement("path", { fill: "#fcdd09", d: "m0-96-4.206 12.944 17.348 53.39h-23.13l-2.599 8h74.163l11.011-8H21.553z" }),
            react_1.default.createElement("path", { stroke: "#fcdd09", strokeWidth: 4, d: "m25.863-35.597 30.564-42.069" })),
        react_1.default.createElement("use", { xlinkHref: "#et_svg__a", transform: "rotate(72)" }),
        react_1.default.createElement("use", { xlinkHref: "#et_svg__a", transform: "rotate(144)" }),
        react_1.default.createElement("use", { xlinkHref: "#et_svg__a", transform: "rotate(216)" }),
        react_1.default.createElement("use", { xlinkHref: "#et_svg__a", transform: "rotate(288)" }))));
exports.default = Et;
//# sourceMappingURL=Et.js.map